<template>
  <div class="result">
    <div class="info-row">
      <b>团队名称：</b>
      <el-select
        v-model="teamId"
        size="medium"
        placeholder="请选择团队"
        @change="getResult"
      >
        <el-option
          v-for="item in list"
          :key="item.teamId"
          :label="item.name"
          :value="item.teamId"
        >
        </el-option>
      </el-select>
      <div class="captain">
        队长姓名：
        <span v-if="teamInfo">{{ teamInfo.captainName }}</span>
      </div>
    </div>

    <el-table :data="teamResult" stripe class="list">
      <el-table-column prop="episode" label="集数" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="文案标题"> </el-table-column>
      <el-table-column label="操作" width="300" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="text"
            @click="
              form = {
                episode: row.episode,
                title: row.title,
                content: row.content,
              };
              show = true;
            "
            >查看文案</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleCheck(row.waId, row.title)"
            >查看脚本</el-button
          >
          <el-button
            v-if="row.originVideo"
            size="mini"
            type="text"
            class="btn"
            @click="
              showVideo = true;
              videoUrl = row.originVideo;
            "
            >源视频</el-button
          >
          <el-button
            v-if="row.productionVideo"
            size="mini"
            type="text"
            class="btn"
            @click="
              showVideo = true;
              videoUrl = row.productionVideo;
            "
            >后期视频</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog class="detail-dialog" :visible.sync="show" width="40%" center>
      <table
        width="100%"
        border="1"
        cellspacing="0"
        cellpadding="10"
        align="center"
        class="table"
      >
        <tr>
          <td class="label" width="20%">集数</td>
          <td>第{{ form.episode }}集</td>
        </tr>
        <tr>
          <td class="label" width="20%">文案名称</td>
          <td>{{ form.title }}</td>
        </tr>
        <tr>
          <td class="label" width="20%">文案内容</td>
          <td><div v-html="form.content"></div></td>
        </tr>
      </table>
    </el-dialog>

    <el-dialog title="脚本列表" :visible.sync="showScenario" width="80%" center>
      <p style="margin-bottom: 10px">
        所属文案名称: <b>{{ waName }}</b>
      </p>
      <el-table :data="sList" stripe class="list">
        <el-table-column type="index" label="序号" width="60" align="center">
        </el-table-column>
        <el-table-column prop="jb" label="景别" width="80" align="center">
        </el-table-column>
        <el-table-column prop="jd" label="角度" width="80" align="center">
        </el-table-column>
        <el-table-column prop="jtsc" label="镜头时长" width="80" align="center">
        </el-table-column>
        <el-table-column
          prop="pshm"
          label="拍摄画面"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sy"
          label="声音"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="py" label="配乐" width="100" align="center">
        </el-table-column>
        <el-table-column
          prop="psdd"
          label="拍摄地点"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="dj" label="道具" width="100" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      class="video-dialog"
      :visible.sync="showVideo"
      width="40%"
      :close-on-click-modal="false"
    >
      <video
        v-if="showVideo"
        style="width: 100%; max-height: 55vh"
        :src="videoUrl"
        controls
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import { teamList } from "@/api/team";
import { result } from "@/api/projectPractice/videoClip";
import { scenarioList } from "@/api/projectPractice/scenario";

export default {
  data() {
    return {
      teamId: null,
      list: [],
      teamResult: [],
      show: false,
      form: {},
      showVideo: false,
      videoUrl: "",
      sList: [],
      waName: "",
      showScenario: false,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    teamInfo() {
      return this.teamId
        ? this.list.find((item) => item.teamId == this.teamId)
        : this.list[0];
    },
  },
  methods: {
    // 团队列表
    getList() {
      teamList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          if (this.list) this.teamId = this.list[0].teamId;

          this.getResult();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 团队结果
    getResult() {
      this.$loading.show();
      result({ teamId: this.teamId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.teamResult = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 脚本详情
    handleCheck(waId, waName) {
      this.waName = waName;
      this.$loading.show();
      scenarioList(waId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.sList = res.data;
          this.showScenario = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  .info-row {
    margin-bottom: 10px;
    text-align: left;
    line-height: 36px;
    overflow: hidden;
    .captain {
      float: right;
      font-weight: bold;
      span {
        color: #409eff;
      }
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
  .detail-dialog {
    .label {
      text-align: center;
      font-weight: bold;
      background: #f5f5f5;
    }
  }
}
</style>